

<template>
  <div class="cmp-distribution-order-shipping-summary">
    <Dropdown2
      id="status"
      :label="$dft.capHead($t('pack_status'))"
      :placeholder="'Choose ' + $dft.capHead($t('pack_status'))"
      :disabled="false"
      :options="packStatusTV"
      :selected="
        packStatusTV.find(
          (e) => e.value == selectedOrder.order_details_tab_packing_shipping.orderline_pack_status_value
        )
      "
      v-on:selectedChange="(e) => onPackStatusChange(e)"
    />

    <TextField2
      id="weight_kg_edit"
      :placeholder="`Type in ${$t('weight_in_kg')}`"
      :label="$t('weight_in_kg')"
      :value="selectedOrder.order_details_tab_summary.order.weight_kg_edit"
      @blur="(e) => onTextFieldValueChange(e)"
      :icon="'calculator'"
      @iconClick="calcClick"
    />
    <!-- <div class="ut-flex"> -->
      <TextField2
        id="tracking_data"
        :placeholder="`${$t('shipping_url')}`"
        :label="`${$t('shipping_url')}`"
        :value="selectedOrder.order_details_tab_summary.order.tracking_data"
        @blur="(e) => onTextFieldValueChange(e)"
        :icon="validUrl!=''?'web-blue':''"
        @iconClick="webClick"
      />
      <!-- <div
            style="position: absolute; top: -11px; right: -28px"
            class="dt-icon-container"
      >
        <img @click="(e) => onClickEditShippingCosts(e)" src="static/icons/web-blue.svg" class="dt-icon v5 s1"/>
      </div>
    </div>   -->
    <Dropdown2
      id="shipping_type_id"
      :label="$dft.capHead($t('shipping_type'))"
      :placeholder="'Choose ' + $dft.capHead($t('Pack shipping_type'))"
      :disabled="false"
      :options="shippingTypeTV"
      :selected="
        shippingTypeTV.find(
          (e) =>
            e.value ==
            selectedOrder.order_details_tab_summary.order.shipping_type_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('shipping_type_id', e)"
    />

    <TextField2
      id="shipping_costs"
      :placeholder="`Type in ${$t('cost')}`"
      :label="`${$t('shipping_costs')}`"
      :value="selectedOrder.order_details_tab_summary.order.shipping_costs"
      @blur="(e) => onTextFieldValueChange(e)"
    />

  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
import { createDropdownConfig } from "@/plugins/dropdown";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
// import AddDeliveryAddress from "./add-delivery-address";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { OrderService } from "../../services/order.service";
import { createTV } from "../../../../models/text-value.model";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
export default {
  components: {
    TextField,
    Dropdown,
    //AddDeliveryAddress,
  },
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  data: function () {
    return {
      // Mark: Data
      
    };
  },
  mounted: function () {},
  watch: {},
  computed: {
    validUrl:function(){
      const value = this.selectedOrder.order_details_tab_summary.order.tracking_data||'';
      const reg =/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

        if (reg.test(value)) {
          return true;
        }else{
          return false;
        } 
    },
    order_id: function () {
      return this.selectedOrder?.order?.order_id||'';
    },
    packStatusTV: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_packing_shipping
            ?.orderline_pack_status,
          "label",
          "value"
        ) || []
      );
    },

    shippingTypeTV: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary
            ?.shipping_types,
          "shipping_type",
          "shipping_type_id"
        ) || []
      );
    },
  },

  methods: {
    webClick:function(){
      window.open(this.selectedOrder.order_details_tab_summary.order.tracking_data)
    },
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };

     
      if (e.name == "tracking_data") {
        const reg =/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

        if (reg.test(e.value)) {
          this.$emit("changed", payload);
          window.open(payload.value)
        } else {
          NotificationService.showNotification({
            text: "Please enter valid URL",
            timeout: 5000,
            type: 'error',
          });
        }
        return;
      }

      this.$emit("changed", payload);
    },

    onDropdownChange: function (name, e) {
      const payload = {
        name: name,
        value: e.value,
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    },
    calcClick:async function () {
      const  res = await OrderService.calculateWeight(this.order_id);
      
      console.log("RES",res)

      const value = res.data.weight?res.data.weight:'';

      const payload = {
        name: 'weight_kg_edit',
        value:value,
      };
      this.$emit("changed", payload);

      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "add_contact_relation",
      //     external_id: this.selectedOrder.order.order_id,
      //     external_table: "l_orders",
      //     key:'delivery_id'
      //   },
      // });
    },

    onPackStatusChange(value) {
      this.$emit('packStatusChanged', value.value);
    }

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-order-shipping-summary {
  width: 100%;
  img {
    .dt-icon {
      .s0 {
        height: 30px;
        width: 30px;
      }
    }
  }
}
</style>
